<template>
  <v-container class="my-0 py-0">
    <p>
      In order to register an admin account, copy the link below or use one of
      the share methods to send it to that person.
    </p>
    <v-row class="mx-2" align="center" justify="center">
      <!--url-->

      <v-col cols="12" xs="12" sm="10" class="px-0">
        <v-text-field
          v-model="userInviteLink"
          hide-details="auto"
          readonly
          id="textToCopy"
        ></v-text-field>
      </v-col>
      <!--/url-->
      <!--copy-to-clipboard-->
      <v-col cols="12" xs="12" sm="2">
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn class="mt-3" color="secondary" @click="copyText()" v-on="on"
              ><v-icon color="white">icons8-copy-to-clipboard</v-icon></v-btn
            >
          </template>
          <span>{{ copyMessage }}</span>
        </v-tooltip>
      </v-col>
      <!--/copy-to-clipboard-->
    </v-row>
    <!--share-links-->
    <v-row class="pa-2" align="center" justify="center">
      <email
        :url="userInviteLink"
        subject="ThinkAir Sign Up"
        scale="2.5"
        class="mr-2 pointer"
      ></email>
      <google :url="userInviteLink" scale="2.5" class="mr-2 pointer"></google>
      <facebook
        :url="userInviteLink"
        scale="2.5"
        class="mr-2 pointer"
      ></facebook>
      <twitter
        :url="userInviteLink"
        title="ThinkAir Sign Up"
        scale="2.5"
        class="mr-2 pointer"
      ></twitter>
      <linkedin
        :url="userInviteLink"
        scale="2.5"
        class="mr-2 pointer"
      ></linkedin>
      <telegram
        :url="userInviteLink"
        scale="2.5"
        class="mr-2 pointer"
      ></telegram>
      <whats-app
        :url="userInviteLink"
        title="ThinkAir Sign Up"
        scale="2.5"
        class="mr-2 pointer"
      ></whats-app>
      <pinterest :url="userInviteLink" scale="2.5" class="pointer"></pinterest>
    </v-row>
    <!--/share-links-->
  </v-container>
</template>

<script>
import {
  Facebook,
  Twitter,
  Linkedin,
  Pinterest,
  Telegram,
  WhatsApp,
  Email,
  Google,
} from "vue-socialmedia-share";

export default {
  name: "InviteUser",
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Telegram,
    WhatsApp,
    Email,
    Google,
  },
  data() {
    return {
      copyMessage: "Copy link",
    };
  },
  computed: {
    userInviteLink() {
      var url = window.location.origin + "/register-admin";
      return url;
    },
  },
  methods: {
    copyText() {
      let input = document.getElementById("textToCopy");
      input.select();
      document.execCommand("copy");
      this.copyMessage = "Link copied!";
    },
  },
};
</script>
